import { createQueryKeys } from '@lukemorales/query-key-factory'
import type { inferQueryKeys } from '@lukemorales/query-key-factory'

export const managers = createQueryKeys('managers', {
  all: null,
})

export type CountryKeys = inferQueryKeys<typeof managers>
